import React from "react"
import partners from "../../images/partners.svg"
import classNames from "classnames"
import {isSandboxEnv, isLocalEnv} from "../../utilities/environment"
export default function PartnersLogos() {
	const isSandbox = isSandboxEnv() || isLocalEnv()
	return (
		<div className="partners-container">
			<div className={classNames("partners-title", {"sandbox-partners-title": isSandbox})}>
				{isSandbox ? "Powering enterprises and startups" : "Powering leading tech brands"}
			</div>
			<div className="partners is-flex">
				<img className="is-flex-grow-1" src={partners} />
			</div>
		</div>
	)
}
